// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scanner_scannerRoot__CNwHe {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000; /* чёрный фон до и после инициализации */
}

.Scanner_videoContainer__vy4Jc {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Подгоняем <video> внутри html5-qrcode под размер контейнера */
.Scanner_videoContainer__vy4Jc video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Storekeeper/ContainersPage/ContainerScannerModal/Scanners/Scanner.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd","sourcesContent":[".scannerRoot {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background: #000; /* чёрный фон до и после инициализации */\r\n}\r\n\r\n.videoContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Подгоняем <video> внутри html5-qrcode под размер контейнера */\r\n.videoContainer video {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scannerRoot": `Scanner_scannerRoot__CNwHe`,
	"videoContainer": `Scanner_videoContainer__vy4Jc`
};
export default ___CSS_LOADER_EXPORT___;
